import { render, staticRenderFns } from "./VoucherScan.vue?vue&type=template&id=6863fb62"
import script from "./VoucherScan.vue?vue&type=script&lang=js"
export * from "./VoucherScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports